module.exports = __webpack_public_path__ + "static/media/phone-detail-view.11dd5ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone-detail-view.png
// module id = 130
// module chunks = 0